import { addAdminFeatureFlagCustomerSlice } from '../../add';
import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsSlice } from '../../get';
import { OverrideAdminFeatureFlagName } from './name';
import { postOverrideAdminFeatureFlagByCustomerId } from '../../../../api';

export const overrideAdminFeatureFlagByCustomerIdSlice = createPostAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			addAdminFeatureFlagCustomerSlice.syncActionCreator
		],
		successActionCreators: [
			getAdminFeatureFlagsSlice.asyncActionCreators.repeatGetAdminFeatureFlags
		]
	},
	name: OverrideAdminFeatureFlagName,
	receive: false,
	request: true,
	requestHandler: postOverrideAdminFeatureFlagByCustomerId
});
